export * from './entity-name-search-results/entity-name-search-results.component';
